import React from 'react';
import { connect } from 'react-redux';
import UsageSummary from './UsageSummary';
import {fetchUsageSummaryData} from '../../../../dataFetchers/usageDataFetcher';
import { getBECompatibleFuelType } from '../../../../helpers/helper';
 
class UsageSummaryContainer extends React.Component{
    componentDidMount(){
        if(!this.props.usageSummary){
            this.props.fetchUsageSummary(this.props.userId, this.props.configs.data["date_format"], getBECompatibleFuelType(this.props.configs.data.fuelType));
        }
    }
    render(){
        return(
            <React.Fragment>
                {this.props.usageSummary !== null && <UsageSummary usageSummaryData={this.props.usageSummary.data} usageSummaryError={this.props.usageSummary.failed} translations={this.props.translations} configs={this.props.configs}/> }
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return{
        userId : state.userIdentityDetails.userId,
        usageSummary : state.usageSummaryData,
        translations: state.translationsData.data,
        configs: state.configs
    }
}

const mapDispatchToProps = dispatch => {
    return{
        fetchUsageSummary: (uuid, dateFormat, measurementType) => dispatch(fetchUsageSummaryData(uuid, dateFormat, measurementType))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsageSummaryContainer);